import { render, staticRenderFns } from "./view-role.vue?vue&type=template&id=50464c5b&scoped=true"
import script from "./view-role.vue?vue&type=script&lang=js"
export * from "./view-role.vue?vue&type=script&lang=js"
import style0 from "./view-role.vue?vue&type=style&index=0&id=50464c5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50464c5b",
  null
  
)

export default component.exports